import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAuthStore } from '@/stores/auth';
import { AvatarUtils } from '@/lib/types/user';

// Pinia store

export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  setup(__props) {

const authStore = useAuthStore();
const { userInfo } = storeToRefs(authStore);

// Computed properties
const avatarUrl = computed(() => {
	return AvatarUtils.getAvatarUrl(userInfo.value);
});

const userInitials = computed(() => {
	return AvatarUtils.getUserInitials(userInfo.value);
});

return { __sfc: true,authStore, userInfo, avatarUrl, userInitials }
}

})